<template>
	<div class="tiptap-blur-source flex">
		<div
			class="
          won-tag-light-gray flex cursor-pointer items-center justify-center
          rounded-l-md border-r border-won-gray-light p-[3px] select-none
      "
			@click="applyTextMinus"
		>
			<MinusIcon
				class="size-[18px]"
			/>
		</div>

		<FloatingElement>
			<template #trigger>
				<div
					class="
                      won-tag-light-gray flex h-full min-w-[29px] cursor-pointer items-center
                      justify-center px-1.5 py-[3px] text-base select-none hover:bg-won-green-light
                  "
				>
					{{ currentSelectedFontSize }}
				</div>
			</template>

			<div class="flex max-h-[220px] flex-col gap-1.5 overflow-y-scroll rounded bg-white shadow-card">
				<div
					v-for="fontSize in FONT_SIZE_OPTIONS"
					:key="fontSize"
					class="cursor-pointer pr-3 pl-2 text-base text-won-black hover:bg-won-gray-light"
					@click="() => setFontSize(fontSize)"
				>
					<span> {{ fontSize }} </span>
				</div>
			</div>
		</FloatingElement>

		<div
			class="
				won-tag-light-gray flex cursor-pointer items-center justify-center
				rounded-r-md border-l border-won-gray-light p-[3px] select-none
			"
			@click="applyTextPlus"
		>
			<PlusIcon
				class="size-[18px]"
			/>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import { PlusIcon, MinusIcon } from '@heroicons/vue/24/outline';
import { useBuilderStyles } from '../../store/builder-style.store';
import { useTiptapStore } from '../../store/tiptap.store';

import FloatingElement from '../library/floting-element.vue';

const tiptap = useTiptapStore();
const { editor, isFocused } = storeToRefs(tiptap);

const builderStyle = useBuilderStyles();
const { nameStyles } = storeToRefs(builderStyle);

const FONT_SIZE_MAX = 29;
const FONT_SIZE_MIN = 14;

const FONT_SIZE_OPTIONS = [14, 16, 18, 20, 22, 24, 26, 28, 29];

const currentSelectedFontSize = computed(() => {
	const documentFontSize = parseInt(nameStyles.value.fontSize.replace('px', '')) - 10;

	if (isFocused.value === true) {
		const selectionFontSize = editor.value?.getAttributes('textStyle')?.fontSize;

		if (selectionFontSize == null) {
			let styles;

			if (editor.value?.options?.isDocumentName === true) {
				styles = document.getElementById('add-name')?.style;
			} else {
				styles = document.getElementById('add-contact')?.style;
			}

			if (styles == null) {
				return '18';
			}

			return styles.getPropertyValue('font-size').replace('px', '');
		}
		return selectionFontSize?.replace('px', '');
		
	}
	return documentFontSize;
	
});

const applyTextPlus = async () => {
	if (isFocused.value === false) {
		builderStyle.textPlus();
		return;
	}

	const newSize = Math.min(parseInt(currentSelectedFontSize.value) + 1, FONT_SIZE_MAX);
	editor.value.chain().focus().setFontSize(`${newSize  }px`).run();
};

const applyTextMinus = async () => {
	if (isFocused.value === false) {
		builderStyle.textMinus();
		return;
	}

	const newSize = Math.max(parseInt(currentSelectedFontSize.value) - 1, FONT_SIZE_MIN);
	editor.value.chain().focus().setFontSize(`${newSize  }px`).run();
};

const setFontSize = async (fontSize) => {
	if (isFocused.value === false) {
		builderStyle.applyFontSize(fontSize);
		return;
	}

	const newSize = Math.max(parseInt(fontSize), FONT_SIZE_MIN);
	editor.value.chain().focus().setFontSize(`${newSize  }px`).run();
};
</script>
